export default "__VITE_ASSET__CVgTNp5U__"